const setAuth = (data) => {
    localStorage.setItem('jwt', data['data']['data'].token);
    localStorage.setItem('name', data['data']['data'].name);
    localStorage.setItem('area_id', data['data']['data'].area_id);
    localStorage.setItem('region_id', data['data']['data'].region_id);
    localStorage.setItem('division', data['data']['data'].division);
}

const getAuth = () => {
    return {
        token: localStorage.getItem('jwt'),
        name: localStorage.getItem('name'),
        areaId: localStorage.getItem('area_id'),
        regionId: localStorage.getItem('region_id'),
        division: localStorage.getItem('division')
    }
}

const setProj = (data) => {
    localStorage.setItem('projId', data.id);
    localStorage.setItem('projName', data.name);
}

const getProj = () => {
    return {
        projId: localStorage.getItem('projId'),
        projName: localStorage.getItem('projName')
    }
}

export { setAuth, getAuth, setProj, getProj }